module.exports = __webpack_public_path__ + "static/media/Care.399f1dc9.svg";